import { Typography } from "@material-tailwind/react";

export function TypographyGradientColor() {
  return (
    <Typography variant="h1" color="blue" textGradient>
      Material Tailwind
    </Typography>
  );
}
